import { NgModule } from '@angular/core';
import { SharedComponentsModule } from './shared-components/shared.components.module';

@NgModule({
  declarations: [],
  imports: [SharedComponentsModule],
  exports: [SharedComponentsModule], // ✅ Add this line
  providers: [],
})
export class SharedModule {}
